import { Skeleton, Text } from '@mantine/core';
import type { Table } from '@tanstack/react-table';
import { cn } from '~/common/string/classname';

export function DataTableResultCount<TData>({
  table,
  suffix,
  className,
  isLoading,
}: {
  table: Table<TData>;
  suffix?: string;
  className?: string;
  isLoading?: boolean;
}) {
  const { length } = table.getFilteredRowModel().rows;

  return isLoading ?
      <Skeleton
        height={24}
        width={80}
      />
    : <Text className={cn('text-xs text-[var(--mantine-color-dimmed)]', className)}>
        <span className="font-medium">{length}</span> {suffix ?? 'results'}
      </Text>;
}
